import React, { Component } from 'react'
import PropTypes from 'prop-types'
import format from 'date-fns/format';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import Paper from '@material-ui/core/Paper';
// import InputLabel from '@material-ui/core/InputLabel';
// import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TableSortLabel from "@material-ui/core/TableSortLabel";
// import Select from '@material-ui/core/Select';
import BreadCrumbNav from '../BreadCrumbNav'
import {Button } from '@material-ui/core';
import './PCSpec.css'
import { getUser,getUserSort,getComparator,stableSort,getFilterOptions} from '../../helpers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

const regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;

class PCSpec extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 100,
      date: null,
      user_name: null,
      user_id : null,
      version: null,
      selected_version : null,      
      pc_name: null,
      mac_add : null,
      
      // userNames: [],
      // selected_user_name : null, 
      // hpa27Names: [],
      // pcNames: [],
      // selected_pc_name : null,

      firstLoad: true, 
      order: "asc", 
      orderBy: "pc_name",
    };
  }

  //サビースタグのサポート表示のURLを作成する関数
  functionUrlCreate = (strSereial = "") => {
    return "https://www.dell.com/support/home/en-vn/product-support/servicetag/" + strSereial + "/overview";
  }
  
  componentDidMount() {
    this.fetchData();
    // this.props.getAppname(); 
  }

  fetchData = () => {
    const { getPCSpecs } = this.props;
    const params = {
      user_name: this.state.user_name,
      pc_name: this.state.pc_name,
      version: this.state.version,
      user_id : this.state.user_id,
      mac_add : this.state.mac_add,
      selected_version : this.state.selected_version,
      //  offset: this.state.offset * this.state.limit, 
      //  limit: this.state.limit,
      date: format(Date.now(), 'yyyy-MM-dd')
    };
    getPCSpecs(params);
  }

  handleClickDownloadCSV = (filteredItems) => {
    // const filteredData = this.props.items.detailData.filter(item =>
    //   (!this.state.user_name || this.state.user_name === item.user_name) &&
    //   (!this.state.hpa27_version || this.state.hpa27_version === item.hpa27_version) &&
    //   (!this.state.pc_name || this.state.pc_name === item.pc_name)
    // );

    // const sortedData = stableSort(filteredData, getComparator(this.state.order, this.state.orderBy));
    const csvRows = ["検索条件："];  

    if (this.state.pc_name === null) {
      csvRows.push("　端末番号: すべて");
    } else if (this.state.pc_name === "")  {
      csvRows.push("　端末番号: 空白");
    } else {
      csvRows.push("　端末番号: " + this.state.pc_name);
    };

    if (this.state.user_name === null) {
      csvRows.push("　ユーザー名: すべて");
    } else if (this.state.user_name === ""){
      csvRows.push("　ユーザー名: 空白");
    } else {
      csvRows.push("　ユーザー名: " + this.state.user_name);
    };

    if (this.state.selected_version === null) {
      csvRows.push("　バージョン: すべて");
    } else if (this.state.selected_version === "") {
      csvRows.push("　バージョン: 空白");
    } else {
      csvRows.push("　バージョン: " + this.state.selected_version);
    };

    const csvHeaderTitles = ["端末番号", "ユーザー名", "バージョン", "型番", "モデル名", "シリアルNo"];
    csvRows.push([csvHeaderTitles.join(',')]);
  
    filteredItems.forEach(item => {
      const row = [
        item.pc_name,
        item.user_name,
        item.hpa27_version,
        item.manufacturer,
        item.system_model,
        item.serial_number
      ];
      csvRows.push(row.join(','));
    });
  
    const csvData = csvRows.join('\n');
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });
    const date = new Date();
    const options = {
      timeZone: "Asia/Tokyo",
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };
    const formattedDate = new Intl.DateTimeFormat('ja-JP', options).format(date).replace(/\D/g, ''); 
    const filename = `導入一覧${formattedDate}.csv`;
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  changePagination = (event, newPage) => {
    const newOffset = newPage - 1;
    this.setState({
      offset: newOffset
    });
  };
  
  render() {
    const user = getUser();
    const {items, isFetching} = this.props
    // const {userNames, pcNames , hpa27Names , items, isFetching, totalRows } = this.props
    // const { limit, offset } = this.state;
    // const sortedItems = items && items.detailData
    //                     ? stableSort(items.detailData, getComparator(this.state.order, this.state.orderBy))
    //                     : [];

    const filteredItems = items
      ? (stableSort(items.detailData || [], getComparator(this.state.order, this.state.orderBy))
        ).filter(
          (item) =>
        {
          return (

          ( this.state.user_name === null ? true : this.state.user_name === "" ? item.user_name === "" 
            : this.state.user_id !== null ? item.user_id === this.state.user_id
            : item.user_name && item.user_name.includes(this.state.user_name)
          ) &&

//           (
//   this.state.mac_add !== null && this.state.pc_name === null
//     ? item.mac_add === this.state.mac_add
//     : this.state.pc_name === null || this.state.pc_name === ""
//       ? true


//       : item.pc_name && item.pc_name.includes(this.state.pc_name)
// )
              ( this.state.pc_name === null ? true : this.state.pc_name === "" ? item.pc_name === "" 
                : this.state.mac_add !== null ? item.mac_add === this.state.mac_add
                : item.pc_name && item.pc_name.includes(this.state.pc_name)
              )&&

          // (this.state.user_id === null  || (this.state.user_id === item.user_id)) &&
          // (this.state.mac_add === null || (this.state.mac_add === item.mac_add)) &&
          (this.state.selected_version === null || (this.state.selected_version === item.hpa27_version)) &&
          // (this.state.user_name === null || (this.state.user_name === "") || (this.state.user_name !== "" && item.user_name.includes(this.state.user_name) )) &&
          (this.state.version === null || (this.state.version === "" ) || (this.state.version !== "" && item.hpa27_version.includes(this.state.version) )) 
          // (this.state.pc_name === null || (this.state.pc_name === "") || (this.state.pc_name !== "" && item.pc_name.includes(this.state.pc_name) )) 
          )
          }
      )
    : [];
   
    // フィルターデータ設定
    let user_options,version_options,pc_spec_options;
    if (filteredItems.length >0){
      user_options=getFilterOptions(filteredItems,["user_id","user_name"],"user_name","user_name")
                  .sort((a, b) => a.user_name.localeCompare(b.user_name, undefined, {sensitivity: "base", numeric: true}));

      version_options=getFilterOptions(filteredItems,"hpa27_version","hpa27_version","hpa27_version")
                  .sort((a, b) => a.hpa27_version.localeCompare(b.hpa27_version, undefined, {sensitivity: "base", numeric: true}));

      pc_spec_options=getFilterOptions(filteredItems,["mac_add","pc_name"],"pc_name","pc_name")
                  .sort((a, b) => a.pc_name.localeCompare(b.pc_name, undefined, {sensitivity: "base", numeric: true}));
    }

    const displayedItems = filteredItems.slice(this.state.offset * this.state.limit, (this.state.offset + 1) * this.state.limit);
    // const displayedItems = filteredItems.slice(offset * limit, (offset + 1) * limit);

    // const filteredItems = items.detailData
    // ? items.detailData
    // : [];

    const createSortHandler = (property) => (event) => {
      const isAsc = this.state.orderBy === property && this.state.order === 'asc';
      const order = {order: isAsc ? 'desc' : 'asc'};
      this.setState(order);

      const orderBy = {orderBy: property};
      this.setState({
        ...order,
        ...orderBy,
        i_num: -1,
        firstLoad: false,
      });
      localStorage.setItem('setting-user-sort', JSON.stringify({...order, ...orderBy}));
    };

        // フィルターデータ変更時の処理
    const handleChangeFilter = (filterDict) => {
      const { changeFilterDatas } = this.props
      this.setState({ ...this.state,firstLoad: false,...filterDict});
      changeFilterDatas({...filterDict});
    };

    return (
      <div className="content-container">
        {this.state.firstLoad && isFetching ? <div className='loading'>お待ちください．．．</div>
          : <>
            <BreadCrumbNav screenName="導入一覧"></BreadCrumbNav>
            <div className="loginname">ログイン名：{user.username}</div>
            <div className="filter-container">
              <FormControl className="formpcspec-filter">
                <Autocomplete
                freeSolo
                id="combo-box-autocomplete-pc_name"
                className="combo-box-autocomplete-pcspec"
                value={this.state.pc_name}
                // onChange={(event, newValue) => {
                //   handleChangeFilter({mac_add:newValue&&newValue.mac_add?newValue.mac_add:null,pc_name: newValue&&newValue.pc_name?newValue.pc_name:"", firstLoad: false , offset: 0});
                // }}
                onChange={(event, newValue) => {
                if (!newValue) {
                  handleChangeFilter({
                    pc_name: null,
                    mac_add: null,
                    firstLoad: false,
                    offset: 0
                  });
                } else {
                  handleChangeFilter({
                    pc_name: newValue?.pc_name ?? "",
                    mac_add: null,
                    firstLoad: false,
                    offset: 0
                  });
                }
              }}
                onInputChange={(event, value) => {
                  if (event && event.type === "change") {
                    handleChangeFilter({pc_name:value,mac_add:null, firstLoad: false , offset: 0});
                  }
                }}
                options={
                  this.state.pc_name && this.state.pc_name.trim() !== "" && pc_spec_options
                    ? pc_spec_options.filter(item => item.pc_name.toLowerCase().includes(this.state.pc_name.toLowerCase()))
                    : pc_spec_options || []
                }
                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.pc_name || ''
                }
                renderInput={(params) => (
                <TextField
                  {...params}
                  className="autocomplete-filter"
                  label="端末番号："
                  variant="outlined"
                  fullWidth
                />
                )}
              />
              </FormControl>

              <FormControl className="formpcspec-filter">
                <Autocomplete
                freeSolo
                id="combo-box-autocomplete-user_name"
                className="combo-box-autocomplete-pcspec"
                value={this.state.user_name}
                onChange={(event, newValue) => {
                  if (!newValue) {
                    handleChangeFilter({
                      user_name: null,
                      user_id: null,
                      firstLoad: false,
                      offset: 0
                    });
                  } else {
                    handleChangeFilter({
                      user_id: newValue.user_id ?? null,
                      user_name: newValue.user_name ?? "",
                      firstLoad: false,
                      offset: 0
                    });
                  }
                }}
                onInputChange={(event, value) => {
                  if (event && event.type === "change") {
                    handleChangeFilter({user_name:value,user_id:null,firstLoad: false , offset: 0 });
                  }
                }}
                options={
                  this.state.user_name && this.state.user_name.trim() !== "" && user_options
                    ? user_options.filter(item => item.user_name.toLowerCase().includes(this.state.user_name.toLowerCase()))
                    : user_options || []
                }
                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.user_name || ''
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="autocomplete-filter"
                    label="ユーザー名："
                    variant="outlined"
                    fullWidth
                  />
                )}
                />
              </FormControl>

              <FormControl className="formpcspec-filter">
                <Autocomplete
                freeSolo
                id="combo-box-autocomplete-hpa27_version"
                className="combo-box-autocomplete-pcspec"
                value={this.state.version}
                onChange={(event, newValue) => {
                  if (!newValue) {
                    handleChangeFilter({
                      version: null,
                      selected_version : null,
                      firstLoad: false,
                      offset: 0
                    });
                  } else {
                    handleChangeFilter({
                      version: newValue.hpa27_version ?? null,
                      selected_version : newValue.hpa27_version ?? null,
                      firstLoad: false,
                      offset: 0
                    });
                  }

                  // handleChangeFilter({selected_version:newValue?newValue.hpa27_version:null,version:"", firstLoad: false , offset: 0});
                }}
                onInputChange={(event, value) => {
                  if (event && event.type === "change") {
                    // handleChangeFilter({ version: value || '', selected_version : null , firstLoad: false , offset: 0 });
                    handleChangeFilter({version:value, selected_version:value ,firstLoad: false , offset: 0 });
                    }
                }}
                options={
                  this.state.version && this.state.version.trim() !== "" && version_options
                    ? version_options.filter(item => item.hpa27_version.toLowerCase().includes(this.state.version.toLowerCase()))
                    : version_options || []
                }
                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.hpa27_version || ''
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="autocomplete-filter"
                    label="バージョン："
                    variant="outlined"
                    fullWidth
                  />
                )}
                />
              </FormControl>

              <FormControl className="pcspec-download">
                <Button
                  variant="contained"
                  color="primary"
                  className="download-button"
                  onClick={()=>this.handleClickDownloadCSV(filteredItems)}
                  disabled={!this.props.items || this.props.items.length === 0}
                >
                  ダウンロード
                </Button>
              </FormControl>

              <div className='pcspec-item-count'>
                <b> 検索結果：{filteredItems.length}件 </b>
              </div>

            </div>
            
            <Paper className="table-root">
              <TableContainer className="pcspec-table-container">
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {/* <TableCell align="center" style={{ minWidth: 100 }}>端末番号</TableCell> */}
                      <TableCell 
                        key="pc_name"
                        align="center" 
                        sortDirection={this.state.orderBy === "pc_name" ? this.state.order : false}
                        style={{ minWidth: 100 }}
                      >              
                        <TableSortLabel
                          direction={this.state.orderBy === "pc_name" ? this.state.order : 'asc'}
                          onClick={createSortHandler("pc_name")}
                        >
                          端末番号
                          {this.state.orderBy === "pc_name" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>  
                      </TableCell>
                      {/* <TableCell align="center" style={{ minWidth: 120 }}>ユーザー名</TableCell> */}
                      <TableCell 
                      key="user_name"
                      align="center" 
                      sortDirection={this.state.orderBy === "user_name" ? this.state.order : false}
                      style={{ minWidth: 120 }}
                      >
                        <TableSortLabel
                          //active={this.state.orderBy === "user_name"}
                          direction={this.state.orderBy === "user_name" ? this.state.order : 'asc'}
                          onClick={createSortHandler("user_name")}
                        >
                          ユーザー名
                          {this.state.orderBy === "user_name" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                            ) : null}
                        </TableSortLabel>                    
                      </TableCell>
                      {/* <TableCell align="center" style={{ minWidth: 120 }}>バージョン</TableCell> */}
                      <TableCell 
                      key="hpa27_version"
                      align="center" 
                      sortDirection={this.state.orderBy === "hpa27_version" ? this.state.order : false}
                      style={{ minWidth: 120 }}
                      >
                        <TableSortLabel
                          //active={this.state.orderBy === "hpa27_version"}
                          direction={this.state.orderBy === "hpa27_version" ? this.state.order : 'asc'}
                          onClick={createSortHandler("hpa27_version")}
                        >
                          バージョン
                          {this.state.orderBy === "hpa27_version" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                            ) : null}
                        </TableSortLabel>                    
                      </TableCell>
                      <TableCell colSpan={3} align="center" style={{ minWidth: 370 }}>PC情報<br />型番 ・ モデル名 ・ シリアルNo.</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayedItems.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell align="center" component="th" scope="row">{item.pc_name}</TableCell>
                        <TableCell align="center">{item.user_name}</TableCell>
                        <TableCell align="center">{item.hpa27_version}</TableCell>
                        <TableCell align="center">{item.manufacturer}</TableCell>
                        <TableCell align="center">{item.system_model}</TableCell>
                        {(item.manufacturer.includes("Dell Inc.")&&regex.test(item.serial_number)===false&&item.serial_number.length===7) ?
                          <TableCell align="center">
                            <a href={this.functionUrlCreate(item.serial_number)} target="_blank" rel="noopener noreferrer">
                              {item.serial_number}
                            </a>
                          </TableCell> :
                          <TableCell align="center">{item.serial_number}</TableCell>
                        }
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>

              </TableContainer>
              {filteredItems.length > 0 && 
                <div className='pagination-button'>
                  <Pagination
                    page={this.state.offset + 1}
                    count={Math.ceil(filteredItems.length / this.state.limit)}
                    onChange={this.changePagination}
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                    showFirstButton
                    showLastButton
                  />
                </div>
              }
            </Paper>
          </>
        }
      </div>
    );
  }
}

PCSpec.propTypes = {
  getPCSpecs: PropTypes.func.isRequired,
  changeFilterDatas: PropTypes.func.isRequired,
};

export default PCSpec;